import React from "react";
import { observer } from "mobx-react";
import { UserAttachmentEditionViewStore } from "../../store";
import { UserAttachmentEditionViewForm } from "./UserAttachmentEditionViewForm";
import { ErrorDialog } from "../../../../common/controls";
import { DownloadIcon } from "../../../../icons";
import { VisibilityIcon } from "../../../../icons";
import { isOriginalCrudStatus, RowCrudStatus } from "../../../common/types";
import { useRootStore } from "../../../../store/contexts";
import { PDFViewerDialog } from "../../../../common/components/PDFViewerDialog";

export type UserAttachmentEditionViewProps = {
  userAttachmentEditionViewStore: UserAttachmentEditionViewStore;
};

export const UserAttachmentEditionView: React.FC<UserAttachmentEditionViewProps> =
  observer(({ userAttachmentEditionViewStore }) => {
    const { langStore } = useRootStore();

    const getViewAction = (
      onDownload: (props: {
        id: string;
        type: string;
        name: string;
        __status__: RowCrudStatus;
      }) => void,
      onViewPdf?: (props: any) => void
    ) => {
      const actions: any[] = [];
      if (onViewPdf) {
        actions.push({
          columnName: "__action_view_pdf",
          onClick: (props: any) =>
            isOriginalCrudStatus(props.__status__) ? onViewPdf(props) : {},
          icon: <VisibilityIcon />,
          label: langStore.viewCommand,
          isActionEnabled: (props: any) =>
            props.name?.toLowerCase().endsWith(".pdf"),
        });
      }
      actions.push({
        columnName: "__action_view",
        onClick: (props: any) =>
          isOriginalCrudStatus(props.__status__) ? onDownload(props) : {},
        icon: <DownloadIcon />,
        label: langStore.downloadCommand,
      });
      return actions;
    };

    return (
      <div>
        <UserAttachmentEditionViewForm
          name={userAttachmentEditionViewStore.nameValue}
          fileFiles={userAttachmentEditionViewStore.fileFiles}
          notes={userAttachmentEditionViewStore.notesValue}
          onPrint={(handlePrint: () => void) =>
            userAttachmentEditionViewStore.printUserAttachmentEdition(
              handlePrint
            )
          }
          onCancel={() =>
            userAttachmentEditionViewStore.cancelUserAttachmentEdition()
          }
          onEdit={
            userAttachmentEditionViewStore.isEditEnabled
              ? () => userAttachmentEditionViewStore.editUserAttachmentEdition()
              : undefined
          }
          fileViewAction={getViewAction(
            (props) =>
              userAttachmentEditionViewStore.fileDownload(props, "file"),
            (props) => userAttachmentEditionViewStore.viewFilePdf(props, "file")
          )}
        />
        <ErrorDialog
          open={userAttachmentEditionViewStore.errorDialogOpened}
          title={userAttachmentEditionViewStore.errorTitle}
          description={userAttachmentEditionViewStore.errorDescription}
          onClose={() => userAttachmentEditionViewStore.closeErrorDialog()}
        />
        <PDFViewerDialog
          open={userAttachmentEditionViewStore.pdfViewerOpen}
          onClose={() => userAttachmentEditionViewStore.closePdfViewer()}
          pdfUrl={userAttachmentEditionViewStore.pdfViewerUrl}
          title={userAttachmentEditionViewStore.pdfViewerTitle}
        />
      </div>
    );
  });
